import { FormLabel } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { ButtonWrapper, RanaButton, RanaModal } from "@nens/ranalib";

import { cancelButtonText } from "@/translations";
import { getDuplicateFileId } from "@/utils/get-duplicate-file-id";
import { getNameFromFileId } from "@/utils/get-name-from-file-id";

interface SchematisationProjectImportOverwriteModalProps {
  path: string;
  selectedName: string;
  existingFileIds: string[];
  isMutating: boolean;
  onClose: () => void;
  onImport: (name: string) => void;
}

export function SchematisationProjectImportOverwriteModal({
  path,
  selectedName,
  existingFileIds,
  isMutating,
  onClose,
  onImport,
}: SchematisationProjectImportOverwriteModalProps) {
  const duplicateName = getNameFromFileId(getDuplicateFileId(path + selectedName, existingFileIds));

  return (
    <RanaModal
      isOpen
      onClose={onClose}
      topBar={
        <FormattedMessage
          id="header.file_conflict"
          defaultMessage="Model schematisation already exists"
        />
      }
      maxW="xl"
      buttons={[
        {
          children: cancelButtonText,
          variant: "tertiary",
          isDisabled: isMutating,
          onClick: onClose,
        },
      ]}
    >
      <FormattedMessage
        id="heading.overwrite_explain"
        defaultMessage="A model schematisation named {name} already exists in this folder. Choose whether to keep the existing model schematisation, upload this one with a different name, or overwrite it."
        values={{ name: path + selectedName }}
      />
      <ButtonWrapper w="fit" py={6} flexDirection="column">
        <FormLabel textTransform="none">{path + selectedName}</FormLabel>
        <RanaButton variant="secondary" isDisabled={isMutating} onClick={onClose}>
          <FormattedMessage id="button.dont_overwrite" defaultMessage="Do not overwrite" />
        </RanaButton>
        <RanaButton
          variant="secondary"
          isDisabled={isMutating}
          onClick={() => onImport(duplicateName)}
        >
          <FormattedMessage
            id="button.upload_as"
            defaultMessage="Upload as `{as}`"
            values={{ as: duplicateName }}
          />
        </RanaButton>
        <RanaButton
          variant="primary"
          isDisabled={isMutating}
          onClick={() => onImport(selectedName)}
        >
          <FormattedMessage id="button.overwrite" defaultMessage="Overwrite" />
        </RanaButton>
      </ButtonWrapper>
    </RanaModal>
  );
}
